import Product from "../../../../../@types/Product";

const BodyColorsE4: Product[] = [
    {
        id: 1,
        name: 'Onyx',
        sku: 'BK01',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/body-colors/black.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/460968ae-1d79-49ab-9a8c-3dd3727a3400'
    },
    {
        id: 2,
        name: 'Aspen',
        sku: 'WH01',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/body-colors/white.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a4654c01-dc80-42f1-7838-feea0621e700'
    },
    {
        id: 3,
        name: 'Caribbean Holiday',
        sku: 'BG09',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/body-colors/turquoise.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/9cc747cd-a163-44c2-38b4-de2f8722f200'
    },
    {
        id: 4,
        name: 'Leaf',
        sku: 'GN07',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/body-colors/leaf.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        inventoryOnlyProduct: true,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/2caffe17-3841-4bb3-9e46-f429f4109600'
    },
    {
        id: 5,
        name: 'Chili Pepper',
        sku: 'RD07',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/body-colors/dior-red.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/4b5ebf2c-f127-4305-a01f-f97c5869df00'
    },
    {
        id: 6,
        name: 'Ocean',
        sku: 'BL10',
        img: `${process.env.PUBLIC_URL}/cart-part-images/eseries/body-colors/electric-blue.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/5f7f927a-a8dd-4581-b5cd-eabc386ef100'
    }
]

export default BodyColorsE4;